import {
    BrowserRouter as Router,
    Routes,
    Route, Navigate,
} from "react-router-dom";
import CreateCampaignPage from "./campaign/CreateCampaignView";
import GetCampaignPage from "./campaign/GetCampaignView";
import HomePage from "./homepage/HomePage";
import AddToCampaignView from "./campaign/AddToCampaignView";
import {Nav, Navbar} from "react-bootstrap";
import fourOFour from "./404";
import AddMetroMedia from "./campaign/AddMetroMedia";
import EditBoard from "./campaign/EditBoard/EditBoard";
import EditCampaignView from "./campaign/EditCampaign/EditCampaignView";
import React from "react";
import Axios from "axios";
import {deleteCookie, getCookie, setCookie} from "./helpers/Cookie";
import ProtectedRoute from "./ProtectedRoute";
import CampaignsView from "./campaign/CampaignsList/CampaignsView";
import CustomNavbar from "./CustomNavbar";
import AccountView from "./user/AccountView";
import {EditBoards} from "./campaign/EditBoards/EditBoards";
import {FilePage} from "./campaign/FilePage";
import FolderView from "./campaign/CampaignsList/FolderView";
import CustomNavigation from "./campaign/CustomNavigation";

function LogoutRoute() {
    deleteCookie("telos_auth");
    window.location.replace("/");
    return <></>;
}

function LayoutWithNavbar({ token }) {
    return (
        <>
            <CustomNavbar/>
            <div className={"main-content"}>
                <Routes>
                    <Route path="/campaigns/create" element={<ProtectedRoute token={token} component={CreateCampaignPage} />} />
                    <Route path="/campaigns/:campaignId/edit-board" element={<ProtectedRoute token={token} component={EditBoard} />} />
                    <Route path="/campaigns/:campaignId/edit-campaign" element={<ProtectedRoute token={token} component={EditCampaignView} />} />
                    <Route path="/campaigns" element={<ProtectedRoute token={token} component={CampaignsView} />} />
                    <Route path="/campaigns/folder/:folderId" element={<ProtectedRoute token={token} component={FolderView} />} />
                    <Route path="/users/account" element={<ProtectedRoute token={token} component={AccountView} />} />
                    <Route path="/campaigns/:campaignId/edit-boards" element={<EditBoards />} />
                    <Route path="/campaign/:campaignId/files" element={<FilePage />} />
                    <Route path="/campaign/:campaignId/upload" element={<AddToCampaignView />} />
                    <Route path="/campaign/:campaignId/add-metro-media" element={<AddMetroMedia />} />
                    <Route path="/campaign/:campaignId" element={<GetCampaignPage />} />
                    <Route path="/logout" element={<LogoutRoute />} />
                    <Route path="*" element={React.createElement(fourOFour)} />
                </Routes>
            </div>
        </>
    );
}

export default function App() {
    if (process.env.NODE_ENV !== "development" && window.location.protocol !== 'https:') {
        //redirect to https if http
        // window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`);
    }
    let urlSearchParams = new URLSearchParams(window.location.search);
    let token = urlSearchParams.get("t");
    if(token){
        setCookie("telos_auth",token);
        if(urlSearchParams.get("signup") === "true"){
            window.location.replace("/users/account");
        }
    }
    token = getCookie("telos_auth");
    if(token) {
        Axios.defaults.headers.common['Authorization'] = token;
        //more token handling. Fetching using happening in ProtectedRoute.js middleware
    }
    return (
        <Router>
            <div>
                <CustomNavigation/>
                <Routes>
                    <Route path="/" element={
                        token ? <Navigate to="/campaigns" replace /> : <Navigate to="/sign-in" replace />
                    }/>
                    <Route path="/sign-in" element={<HomePage />}/>
                    <Route path="/*" element={<LayoutWithNavbar token={token} />} />
                </Routes>
            </div>
        </Router>
    );
}
